import React from 'react'
import { connect } from 'react-redux'
import NextButton from '../components/NextButton'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'

import { createSelector } from 'reselect'
import { nextStop } from 'aria-viewer/stopselector/stopsListActions'
import getters from 'aria-viewer/utils/selectorGetters'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import compose from 'recompose/compose'

const nextStopSelector = createSelector(
    getters.tour.stopsList,
    getters.tour.stopIndex,
    (stopsList, stopIndex) => {
        const nextStop = stopIndex >= stopsList.size - 1 ? stopsList.get(0) : stopsList.get(stopIndex + 1)

        // Handles single scenes
        if (stopsList.size === 1) {
            return {}
        } else {
            return nextStop || {}
        }
    }
)

const WithDontRenderSingleMedia = WrappedComponent => ({ isSingleMedia, ...props }) =>
    isSingleMedia ? null : <WrappedComponent {...props} />

const mapStateToProps = (state, ownProps) => {
    const { title } = ownProps.title ? { title: ownProps.title } : nextStopSelector(state)
    const isMobile = state.getIn(['device', 'isDeviceMobile']) !== null
    const { isSingleMedia } = mapSelectorsToProps(['isSingleMedia'])()(state)
    const useResponsiveUI = QueryParamUtils.useResponsiveUI()

    return {
        title,
        isMobile,
        isSingleMedia,
        useResponsiveUI,
        viewportWidth: state.getIn(['device', 'viewportWidth']),
        viewportHeight: state.getIn(['device', 'viewportHeight']),
    }
}

const mapDispatchToProps = dispatch => ({
    onClick: e => {
        dispatch(nextStop(e))
    },
})

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    WithDontRenderSingleMedia
)(NextButton)
